<template>
  <v-speed-dial
    v-model="fab"
    direction="right"
    fixed
    left
    bottom
    transition="slide-x-transition"
    style="z-index:9;"
  >
    <template v-slot:activator>
      <v-btn v-model="fab" color="blue darken-2" dark fab>
        <v-icon v-if="fab">mdi-close</v-icon>
        <v-icon v-else>mdi-store-edit-outline</v-icon>
      </v-btn>
    </template>
<!--     <v-btn fab dark small color="green" title="Completa info prodotti" @click="popolaInfoProdotti">
      <v-icon>mdi-wrench-outline</v-icon>
    </v-btn> -->
    <v-btn fab dark small color="green" title="Export Comparazione" @click="exportRiepilogo">
      <v-icon>mdi-chart-box-plus-outline</v-icon>
    </v-btn>
<!--     <v-btn fab dark small color="indigo" title="Stampa movimenti">
      <v-icon>mdi-printer</v-icon>
    </v-btn> -->
<!--     <v-btn fab dark small color="red">
      <v-icon>mdi-card-bulleted-outline</v-icon>
    </v-btn> -->
  </v-speed-dial>
</template>

<script>
export default {
  data() {
    return {
      fab: false
    }
  },
  methods: {
    /*     popolaInfoProdotti() {
      this.$emit('comando', 'popola-info-prodotti')
    }, */
    exportRiepilogo() {
      this.$emit('comando', 'export-riepilogo')
    }
  }  
}
</script>